import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import {
  DESELECT_MESSAGE,
  PROJECT_CHECKLIST_STATUS,
} from '../../../../../../../../common/constants';
import CommonTooltip from '../../../../../../../../components/CommonTooltip';
import StageItemTable from './StageItemTable';

const StageItemList = ({
  stageId,
  eqcTypeData,
  isEditable,
  selectedStageData,
  setIsStageItemSelectionActive,
  isStageSelectionActive,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSelectAllAcrossPages, setIsSelectAllAcrossPages] = useState(false);
  const [exceptIds, setExceptIds] = useState([]);

  const isBulkEnabled =
    isEditable &&
    eqcTypeData?.status !== PROJECT_CHECKLIST_STATUS?.PUBLISHED &&
    eqcTypeData?.status !== PROJECT_CHECKLIST_STATUS?.ARCHIVED &&
    eqcTypeData?.project?.isActive;

  useEffect(() => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setIsSelectAllAcrossPages(false);
    setExceptIds([]);
  }, [stageId]);

  useEffect(() => {
    setIsStageItemSelectionActive?.(
      selectedRows?.length > 0 || isSelectAllAcrossPages,
    );
  }, [selectedRows, isSelectAllAcrossPages, setIsStageItemSelectionActive]);

  const handleClearSelection = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setIsSelectAllAcrossPages(false);
    setExceptIds([]);
  };

  return (
    <div className="stage-item-card project-checklist">
      <div className="header d-flex align-center justify-between mb-10">
        <div className="d-flex align-center">
          <div id="stage-item-selection-bar" />
        </div>
        <div className="eqc-stage-header-buttons d-flex">
          <div id="stageitem-add-btn" />
        </div>
      </div>
      <div className={clsx(isStageSelectionActive && 'stage-item-disabled')}>
        {isStageSelectionActive && (
          <CommonTooltip title={DESELECT_MESSAGE}>
            <div className="disabled-overlay" />
          </CommonTooltip>
        )}
        <StageItemTable
          stageId={stageId}
          eqcTypeData={eqcTypeData}
          isEditable={isEditable}
          selectedStageData={selectedStageData}
          isBulkEnabled={isBulkEnabled}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          isSelectAllAcrossPages={isSelectAllAcrossPages}
          setIsSelectAllAcrossPages={setIsSelectAllAcrossPages}
          exceptIds={exceptIds}
          setExceptIds={setExceptIds}
          onClearSelection={handleClearSelection}
          isStageSelectionActive={isStageSelectionActive}
        />
      </div>
    </div>
  );
};

export default StageItemList;
